
import { useCallback, useEffect, useState } from 'react';
// New Products lives inside the customer area now, so it carries the customer
// header and footer - the public Header sent a signed-in customer back to the
// landing page.
import HeaderCustomer from './components/customer/HeaderCustomer';
import CustomerFooter from './components/customer/CustomerFooter';
import './App.css'
import { Table } from 'react-bootstrap';
import ApiHandler from './ApiHandler';
import LoaderTri from './components/Loader/LoaderTri';
import FirmPicker from './components/FirmPicker';


export default function New_Product() {

    const [newProduct, setNewProduct] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [firmId, setFirmId] = useState(null);

    // NewProducts is per firm, so the list follows the dropdown. FirmPicker's
    // onReady drives the first load - the group list arrives after mount.
    const loadNewProducts = useCallback((clientId) => {
        if (!clientId) {
            setNewProduct([]);
            return undefined;
        }

        setIsLoading(true)

        const cancelToken = ApiHandler.cancelToken;
        const source = cancelToken.source();
        ApiHandler.get({

            url: "/api/POPSReports/NewProducts/" + clientId,
            cancelToken: source.token

        })
            .then(((result) => {

                console.log(result);
                setNewProduct(result)
            }))
            .catch(err => {
                console.error(err);
                if (err.response && err.response.status && err.response.status === 401) {
                    console.log(err.response);
                }

            })
            .finally(() => {
                setIsLoading(false)

            })
        return () => {
            source.cancel()
        }
    }, []);

    useEffect(() => {
        const cancel = loadNewProducts(firmId);
        return () => {
            if (cancel) cancel();
            setNewProduct([]);
        };
    }, [firmId, loadNewProducts]);

    const firmHandler = (firm) => setFirmId(firm ? firm.wClientId : null);

    return (

        <div className='custShell'>
            <HeaderCustomer />

            <div className='custMain'>
            <br />
            <div className='row m-0'>
                <div className='col-lg-12 text-center' >
                    <h5>New Products</h5>
                    <FirmPicker onReady={firmHandler} onChange={firmHandler} />
                </div>
                <div className='col-lg-8 offset-lg-2'>

                    <div className="grids" style={{
                        width: "100%",
                        // marginLeft: "230px",
                        overflowX: "scroll"
                    }}>
                        <Table striped
                            style={{ border: "1px solid black", }} >
                            <thead style={{ backgroundColor: "#3ca0e7", color: "white" }}>
                                <tr style={{ border: "1px solid black", }}>
                                    <th style={{ minWidth: "200px", border: "1px solid black", }}>Product Name</th>
                                    <th style={{ border: "1px solid black", }}>Packing</th>
                                    <th style={{ border: "1px solid black", }}>Scheme</th>
                                    <th style={{ border: "1px solid black", }}>MRP</th>
                                </tr>
                            </thead>
                            <tbody >

                                {newProduct.map((elm, i) => {
                                    return <tr key={i}>
                                        <td >{elm.prodName}</td>
                                        <td > {elm.case1}</td>
                                        <td>{elm.scheme}</td>
                                        <td>{elm.mrp}</td>
                                    </tr>

                                })}

                            </tbody>
                        </Table>

                        {isLoading && <LoaderTri />}

                    </div>
                </div>
            </div>

            </div>

            <CustomerFooter />
        </div>
    )
}

